import { Download, Print } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { format, parse } from 'date-fns';
import React from 'react';
import { useAsyncFn } from 'react-use';
import { documentDownload, genFatt } from '../../../../api/testataordine';
import useBSSLogger from "../../../../hooks/useBSSLogger";
import __t from '../../../../lib/traduzioni';
import TabelleEntries from '../../../TabelleEntries';
const {logger} = useBSSLogger();

//tab con i documenti e le stampe relative all'ordine
const TabStampe = ({ ordine, tabObj }) => {

    const {documenti = []} = ordine;

    const [{ loading, error, value }, execStampa] = useAsyncFn(async (iddoc, idtipodoc) => {
        logger.debug("stampo il documento", iddoc, idtipodoc)
        const res = await documentDownload(iddoc, idtipodoc);
        return res;
    });

    const tabellaDocumenti = {
        [__t("documenti")]: documenti.reduce((obj, doc) => {
            

            const data = format(parse(doc.datadocumento, "T", new Date()), "dd/MM/yyyy")

            const label = `${doc.tipodocumento.nome} ${__t("del")} ${data}`;


            return {
                ...obj,
                [label]: (<LoadingButton 
                    size="small" 
                    startIcon={<Print />} 
                    loadingPosition="start" 
                    loading={loading}
                    variant="contained"                    
                    onClick={e => {
                        
                        execStampa(doc.iddocumento, doc.tipodocumento.id)
                    }}
                >
                    {__t("stampa")}
                </LoadingButton>)
            }
        }, {})
    }

    return (
        <>
            <TabelleEntries tabelle={tabellaDocumenti} wrapped />
        </>
    )
};

export default TabStampe;